// 定数
const SELECTORS = {
  MODAL: {
    HEADER: ".header",
  },
  LINK: {
    PAGE: 'a[href^="#"]',
  },
};

const ANIMATION = {
  DURATION: 500,
};

/**
 * スムーズスクロール管理クラス
 */
export class SmoothScroll {
  constructor() {
    this.init();
  }

  /**
   * 初期化処理
   */
  init() {
    this.initPageLinks();
    this.initHashScroll();
  }

  /**
   * ページ内リンクの初期化
   */
  initPageLinks() {
    document.querySelectorAll(SELECTORS.LINK.PAGE).forEach((link) => {
      link.addEventListener("click", (e) => {
        e.preventDefault();
        const targetId = link.getAttribute("href");
        if (targetId === "#") return;

        const targetElement = document.querySelector(targetId);
        if (targetElement) {
          const targetPosition = this.calculateTargetPosition(targetElement);
          this.scroll(targetPosition);
        }
      });
    });
  }

  /**
   * ターゲット要素の位置を計算
   * @param {HTMLElement} targetElement - ターゲット要素
   * @returns {number} スクロール位置
   */
  calculateTargetPosition(targetElement) {
    const header = document.querySelector(SELECTORS.MODAL.HEADER);
    const isHeaderFixed = header && window.getComputedStyle(header).position === "fixed";
    const headerHeight = isHeaderFixed ? header.offsetHeight : 0;
    return targetElement.getBoundingClientRect().top + window.pageYOffset - headerHeight - 80;
  }

  /**
   * スムーズスクロール
   * @param {number} targetPosition - 目標位置
   * @param {number} duration - アニメーション時間
   */
  scroll(targetPosition, duration = ANIMATION.DURATION) {
    const startPosition = window.pageYOffset;
    const distance = targetPosition - startPosition;
    let startTime = null;

    const animation = (currentTime) => {
      if (startTime === null) startTime = currentTime;
      const timeElapsed = currentTime - startTime;
      const progress = Math.min(timeElapsed / duration, 1);

      const ease = this.easeInOutQuad(progress);
      window.scrollTo(0, startPosition + distance * ease);

      if (timeElapsed < duration) {
        requestAnimationFrame(animation);
      }
    };

    requestAnimationFrame(animation);
  }

  /**
   * easeInOutQuadイージング関数
   * @param {number} progress - 進行度（0-1）
   * @returns {number} イージング値
   */
  easeInOutQuad(progress) {
    return progress < 0.5 ? 2 * progress * progress : 1 - Math.pow(-2 * progress + 2, 2) / 2;
  }

  initHashScroll() {
    const targetId = window.location.hash;

    if (!targetId || targetId === "#") {
      return;
    }

    const targetElement = document.querySelector(targetId);

    if (!targetElement) {
      return;
    }

    window.addEventListener("load", () => {
      const targetPosition = this.calculateTargetPosition(targetElement);
      this.scroll(targetPosition);
    });
  }
}
